module.exports = __webpack_public_path__ + "static/image21-67cdd4f8faf9cab363d40f176ccad700.jpg";